import React from 'react';
import './FilterButton.scss';

export default function FilterButton({ onClick }) {
	return (
		<button 
			className="FilterButton"
			onClick={onClick}
			type="button"
		>
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
			</svg>
			<span>Filter</span>
		</button>
	);
}

